<template>
  <div>
    <b-alert
      :show="denied"
      variant="warning"
    >
      <div class="alert-body">
        {{ $t('projects.edit.denied') }}
      </div>
    </b-alert>
    <b-alert
      v-if="isLocked"
      variant="warning"
      show
      class="mb-1"
    >
      <feather-icon
        icon="LockIcon"
        class="mr-1"
      />
      {{ $t('projects.edit.locked') }}
    </b-alert>
    <validation-observer
      v-if="!denied"
      ref="simpleRules"
    >
      <projects-item-form :read-only="isLocked" />
      <save-button
        v-if="!isLocked"
        :save-action="submitForm"
        :is-disabled="submitStatus"
      />
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { BAlert } from 'bootstrap-vue'
import { canWriteProject } from '@/auth/taskPermissions'
import { statusSlug } from '@/libs/definitions'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ProjectsItemForm from '@/views/Projects/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    ProjectsItemForm,
    ValidationObserver,
    SaveButton,
    BAlert,
  },
  data() {
    return {
      submitStatus: false,
      loaded: false,
    }
  },
  computed: {
    denied() {
      if (!this.loaded || this.$store.getters['projects/loading']) return false
      return !this.itemData?.id || !canWriteProject(this.itemData)
    },
    itemData() {
      return this.$store.getters['projects/dataItem']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
    isLocked() {
      return ['completed', 'cancelled'].includes(statusSlug('project', this.itemData))
    },
  },
  watch: {
    saveData(val) {
      if (val.watcherError) {
        this.showToast({
          variant: 'warning', title: this.$t('common.toast.warning'), icon: 'AlertTriangleIcon', text: this.$t('projects.form.watcherError'),
        })
      }
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/app/projects')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('projects/getDataItem', this.$route.params.id)
        .finally(() => { this.loaded = true })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('projects/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'),
            icon: 'XIcon',
            text: this.$t('common.requiredFields'),
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
